import { compose, withHandlers, withPropsOnChange, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import { EventEmitter } from 'events';
import { getBarbersFromFilterSorted, getDate } from '../../../appointmentSelector';
import { fetchShopSideBySide, fetchBarberSideBySide } from '../actions';
import SideBySideView from '../sideBySideView';
import { USER_TYPES } from '../../../../../auth/constants';
import { getShop } from '../../../../../auth/selectors';
import {
  getBarbersForSideBySide,
  getBlockedTimes,
  getCalendar,
  getWorkday,
} from '../selectors';
import fetchTimeTracking from '../../../../timeTracker/hoc/sideBySideFetchTimeTracking';

const SideBySideContainer = compose(
  connect(
    state => ({
      currentDate: getDate(state),
      barbers: getBarbersForSideBySide(state),
      noBarbersWorking: !getBarbersForSideBySide(state).length,
      noBarbersSelected: !getBarbersFromFilterSorted(state).length,
      shop: getShop(state),
      user: state.auth.user,
      barberUser: state.auth.barberUser,
      calendarWorkDay: getCalendar(state),
      blockedTimes: getBlockedTimes(state),
      workday: getWorkday(state),
    }),
    { fetchShopSideBySide, fetchBarberSideBySide }
  ),
  fetchTimeTracking,
  withHandlers({
    fetch: props => ({ showLoading = false } = {}) => {
      const {
        shop,
        currentDate,
        user,
        barberUser,
      } = props;

      switch (user.kind) {
        case USER_TYPES.shop:
          props.fetchShopSideBySide(shop, currentDate, showLoading);
          props.fetchTimeTracking();
          break;
        case USER_TYPES.barber:
          props.fetchBarberSideBySide(barberUser.id, currentDate, showLoading);
          break;
        default:
      }
    },
    openBlockTime: props => () => {
      const data = {};
      if (props.user && props.user.kind === USER_TYPES.barber) {
        data.hideBarber = true;
        data.barberId = props.barberUser.id;
      }
      EventEmitter.prototype.emit('open-block-time-modal', data);
    },
  }),
  withPropsOnChange(
    ['currentDate'],
    (props) => {
      if (props.currentDate) props.fetch({ showLoading: true });
    }
  ),
  lifecycle({
    componentDidMount() {
      EventEmitter.prototype.on('reload-side-by-side', this.props.fetch);
    },
    componentWillUnmount() {
      EventEmitter.prototype.removeListener('reload-side-by-side', this.props.fetch);
    },
  })
)(SideBySideView);

export default SideBySideContainer;
